document.addEventListener('DOMContentLoaded', function() {
    var carousels = document.querySelectorAll('.product-carousel');

    carousels.forEach(function(carousel) {
        var searchTerm = carousel.getAttribute('data-search-term');
        var productCount = parseInt(carousel.getAttribute('data-product-count'), 10) || 3;

        if (!searchTerm) {
            console.error('No search term found for carousel:', carousel.id);
            return;
        }

        var searchUrl = buildSearchUrl(searchTerm);
        if (!searchUrl) {
            console.error('Failed to build search URL for term:', searchTerm);
            return;
        }

        console.log('Fetching products for carousel:', carousel.id, 'from URL:', searchUrl);
        fetchProducts(searchUrl, carousel, productCount);
    });

    function buildSearchUrl(searchTerm) {
        var encodedSearchTerm = encodeURIComponent(searchTerm);
        var encodedDomainTerm = encodeURIComponent(searchTerm.replace(/\s+/g, '+'));
        return `https://v308y4.a.searchspring.io/api/search/search.json?q=${encodedSearchTerm}&domain=https%3A%2F%2Ffootwearetc.com%2Fcollections%2Fshop%3Fq%3D${encodedDomainTerm}&sessionId=71527a33-91a3-4c54-aa2f-3e3c8ecdc58e&pageLoadId=b92eaffa-4414-47fb-baa5-b3f9a4b9edbf&siteId=v308y4&redirectResponse=full&ajaxCatalog=Snap&resultsFormat=native`;
    }

    function fetchProducts(searchUrl, carousel, productCount) {
        fetch(searchUrl, { credentials: 'same-origin' })
        .then(response => {
            console.log('Received response from:', searchUrl);
            if (!response.ok) {
                throw new Error(`Network response was not ok: ${response.statusText}`);
            }
            return response.json();
        })
        .then(data => {
            var products = data.results.slice(0, productCount);  // Get the specified number of products
            console.log('Found products:', products.length);
            if (products.length === 0) {
                console.error('No products found in the response.');
            }
            renderProducts(products, carousel);
        })
        .catch(error => console.error('Error fetching products:', error));
    }

    function renderProducts(products, carousel) {
        console.log('Rendering products for carousel:', carousel.id);
        carousel.innerHTML = '';  // Clear any existing content

        products.forEach(product => {
            var productLink = product.url;
            var productImage = product.thumbnailImageUrl;
            var productName = product.name;
            var productSalePrice = product.price;
            var productRegularPrice = product.originalPrice;
            var productDescription = product.description || '';

            console.log('Product details - Name:', productName, 'Sale Price:', productSalePrice, 'Regular Price:', productRegularPrice, 'Link:', productLink);

            var shortDescription = getShortDescription(productDescription);
            var priceHTML = '';

            if (productRegularPrice && parseFloat(productSalePrice) < parseFloat(productRegularPrice)) {
                priceHTML = `<span style="color: red;">$${productSalePrice}</span> <span style="text-decoration: line-through;">$${productRegularPrice}</span>`;
            } else {
                priceHTML = `<span>$${productSalePrice}</span>`;
            }

            var productHTML = `
                <div class="product-item" style="flex: 1; padding: 10px; box-sizing: border-box;">
                    <a href="${productLink}">
                        <img src="${productImage}" alt="${productName}" style="width: 100%;" />
                    </a>
                    <h2>${productName}</h2>
                    <p>${shortDescription} <a href="${productLink}">Read more</a></p>
                    <p>${priceHTML}</p>
                </div>
            `;

            carousel.innerHTML += productHTML;
        });

        // Apply flexbox to display items in a row
        carousel.style.display = 'flex';
        carousel.style.justifyContent = 'space-between';

        // Initialize your carousel
        initializeCarousel(carousel);
    }

    function getShortDescription(description) {
        if (!description) return '';
        var sentences = description.split('. ');
        var twoSentences = sentences.slice(0, 2).join('. ') + '.';
        var words = description.split(' ');
        var twentyFiveWords = words.slice(0, 25).join(' ');
        return (twentyFiveWords.length < twoSentences.length) ? twentyFiveWords + '...' : twoSentences;
    }

    function initializeCarousel(carousel) {
        console.log('Initializing carousel for:', carousel.id);

        var items = carousel.querySelectorAll('.product-item');
        var currentIndex = 0;

        function showItem(index) {
            items.forEach((item, i) => {
                item.style.display = (i >= index && i < index + 3) ? 'block' : 'none';
            });
        }

        showItem(currentIndex);

        var prevButton = document.createElement('button');
        prevButton.textContent = 'Previous';
        prevButton.className = 'carousel-prev';
        prevButton.onclick = function() {
            currentIndex = (currentIndex === 0) ? items.length - 1 : currentIndex - 1;
            items[currentIndex].parentNode.insertBefore(items[currentIndex], items[0]);
            showItem(0);
        };

        var nextButton = document.createElement('button');
        nextButton.textContent = 'Next';
        nextButton.className = 'carousel-next';
        nextButton.onclick = function() {
            currentIndex = (currentIndex === items.length - 1) ? 0 : currentIndex + 1;
            items[currentIndex].parentNode.appendChild(items[currentIndex]);
            showItem(0);
        };

        carousel.appendChild(prevButton);
        carousel.appendChild(nextButton);
    }
});
